import * as React from 'react';
import { observer } from 'mobx-react';

import { liveAnnounce } from 'uitk-react-utils';

import { FILTER_TYPE_TO_VALUE } from 'utility/filter-constants';
import { useStores, useHydrationEnable } from 'utility/hooks';

import { ButtonToggleTracked } from 'components/shared/tracked';
import { FlightsCardDisplayFilterItemType } from 'types/shared';

export interface CardDisplayFilterItemProps {
  filterItem: FlightsCardDisplayFilterItemType;
  idPrefix: string;
  keySuffix: string;
  updateFilter: (keySuffix: string) => void;
}

export const CardDisplayFilterItem = observer((props: CardDisplayFilterItemProps) => {
  const hydrated = useHydrationEnable();
  const { sortFilterStore } = useStores();

  const handleOnChange = () => {
    const { filterItem, keySuffix, updateFilter } = props;
    const {
      filterPresentation: { accessibility }
    } = sortFilterStore;
    filterItem.selected = !filterItem.selected;

    if (filterItem.selected) {
      sortFilterStore.increaseAppliedFilterCount();
    } else {
      sortFilterStore.decreaseAppliedFilterCount();
    }

    updateFilter(keySuffix);
    liveAnnounce(accessibility.onCompletion);
  };

  const { filterItem, idPrefix } = props;
  const { deselectAnalytics, label, subLabel, selectAnalytics, value, selected, accessibility } = filterItem;

  const filterValue = FILTER_TYPE_TO_VALUE[value.__typename](value);
  const elementId = `${idPrefix}-${filterValue}`;
  const iconId = filterItem.card.id;
  const filterAnalytics = selected ? deselectAnalytics : selectAnalytics;

  return (
    <ButtonToggleTracked
      id={elementId}
      data-test-id={elementId}
      value={filterValue}
      name={idPrefix}
      icon={iconId}
      stacked
      labelText={label}
      subLabelText={subLabel}
      checked={selected}
      onChange={handleOnChange}
      disabled={!hydrated}
      aria-label={accessibility.usage}
      {...filterAnalytics}
    />
  );
});
